var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{staticClass:"SearchButton-wrapper"},[_c('div',{staticClass:"SearchButton",class:_vm.componentClasses,on:{"click":_vm.onClick}},[_c('span',{staticClass:"close-icon"}),_c('span',{staticClass:"search-icon"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }